var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.491 1.66602H6.50768C3.47435 1.66602 1.66602 3.47435 1.66602 6.50768V13.4827C1.66602 16.5243 3.47435 18.3327 6.50768 18.3327H13.4827C16.516 18.3327 18.3243 16.5243 18.3243 13.491V6.50768C18.3327 3.47435 16.5243 1.66602 13.491 1.66602ZM13.4993 15.2077C12.5577 15.2077 11.791 14.441 11.791 13.4993C11.791 12.9493 12.0577 12.466 12.466 12.1493C12.116 11.2327 11.241 10.5993 10.2577 10.6327L8.54102 10.641H8.53268C8.02435 10.641 7.54102 10.491 7.13268 10.2327V11.916C7.76602 12.166 8.21602 12.7827 8.21602 13.4993C8.21602 14.441 7.44935 15.2077 6.50768 15.2077C5.56602 15.2077 4.79935 14.441 4.79935 13.4993C4.79935 12.7743 5.24935 12.166 5.88268 11.916V8.29102C5.24935 7.99935 4.79935 7.36602 4.79935 6.62435C4.79935 5.61602 5.62435 4.79102 6.63268 4.79102C7.64102 4.79102 8.46602 5.61602 8.46602 6.62435C8.46602 7.44102 7.92435 8.12435 7.18268 8.36602C7.34935 8.97435 7.89935 9.39935 8.53268 9.39935C8.53268 9.39935 8.53268 9.39935 8.54102 9.39935L10.2577 9.39102C10.266 9.39102 10.266 9.39102 10.2743 9.39102C11.8077 9.39102 13.1827 10.366 13.6827 11.816C14.541 11.9077 15.216 12.6243 15.216 13.5077C15.2077 14.441 14.441 15.2077 13.4993 15.2077Z",
    fill: "url(#paint0_linear_7035_124509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7035_124509",
    x1: 9.9952,
    y1: 1.66602,
    x2: 9.9952,
    y2: 18.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212529"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsActiveDark);
export default __webpack_public_path__ + "static/media/tools-active-dark.72519a6abe762e8ff0b91dac1a88c067.svg";
export { ForwardRef as ReactComponent };